import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class PackingMethodsDTO {
    @ApiProperty()
    @IsOptional()
    packingMethodId?: number;
    @ApiProperty()
    @IsNotEmpty({ message: "Packing Method Name should not be empty" })
    packingMethodName: string;
    @ApiProperty()
    @IsNotEmpty({ message: "Number Of Pouches should not be empty" })
    palletCapacity: number;
    @IsNotEmpty({ message: "Number Of Pouches should not be empty" })
    maxPalletCapacity: number;
    @ApiProperty()
    @IsNotEmpty({ message: "Number Of Pouches should not be empty" })
    noOfPouches: number;
    @ApiProperty()
    pouchesPerRow: number;
    @ApiProperty()
    uomId: number;
    @ApiProperty()
    isActive: boolean;
    createdAt: Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Created User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
    createdUser: string;

    updatedAt: Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Updated User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    grossWeight: number;
}

